import Util from '../../lib/util'
import url from '../../lib/url'
import Vue from 'vue'
let vm = new Vue({});

function downLoad(href, title, params, method = 'get') {
  return new Promise((resolve, reject) => {
    vm.$Message.loading({
      content: '下载中...',
      duration: 0,
      closable: true
    });
    const date = this.$moment(new Date()).format('YYYYMMDDHHmm');
    let fullUrl = params ? url + fmtHref(href, params) : url + href;

    const xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`);

    if (method.toLowerCase() === 'post') {
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    }

    xhr.onload = function () {
      if (xhr.status === 200) {
        const blob = new Blob([this.response], { type: 'application/vnd.ms-excel' });
        const a = document.createElement('a');
        const downloadUrl = window.URL.createObjectURL(blob);

        const contentDisposition = xhr.getResponseHeader('Content-Disposition');
        let fileName = `${title}_${date}.xlsx`;
        if (contentDisposition) {
          // 优先处理UTF-8编码的文件名（RFC 5987）
          const utf8Filename = contentDisposition.match(/filename\*=UTF-8''(.+?)(;|$)/i);
          if (utf8Filename && utf8Filename[1]) {
            fileName = decodeURIComponent(utf8Filename[1]);
          } else {
            // 处理普通文件名（带引号和不带引号的情况）
            const fileNameMatch = contentDisposition.match(/filename=["']?([^;]+)["']?/i);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1].replace(/['"]/g, '');
            }
          }
        }

        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
        vm.$Message.destroy();
        resolve({ status: 200, msg: '下载成功' });
      } else {
        vm.$Message.destroy();
        vm.$Message.error({
          content: '下载失败，请重试',
          duration: 5,
          closable: true
        });
        reject({ status: 500, msg: '下载失败，请重试' });
      }
    };

    xhr.onerror = function () {
      vm.$Message.destroy();
      vm.$Message.error({
        content: '下载失败，请重试',
        duration: 5,
        closable: true
      });
      reject({ status: 500, msg: '下载失败，请重试' });
    };

    xhr.send(method.toLowerCase() === 'post' ? JSON.stringify(params) : null);
  });
}

// 参数拼接
function fmtHref(href, params) {
  const paramsArr = [];
  // 轮询对象的属性
  Object.keys(params).forEach((key) => {
    const tempValue = params[key];
    if (!tempValue) {
      // 删除对象中值为 undefined 的属性
      delete params[key];
    } else {
      // 对属性值进行编码，并且在属性与值之间加上 '=' 符号
      paramsArr.push([key, encodeURIComponent(tempValue)].join("="));
    }
  });
  return href + '?' + paramsArr.join("&");
}

export default downLoad;